import { getDate, getMonth, getYear } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

export const getYearMonthDay = (date: Date): [number, number, number] => {
  return [getYear(date), getMonth(date), getDate(date)];
};

export const makeDateInTZ = (timeZone: string, year: number, month0: number, day: number, hour: number = 0, minute: number = 0) => {
  // month0 is 0-based, so add 1 for the string
  const MM = String(month0 + 1).padStart(2, '0');
  const dd = String(day).padStart(2, '0');
  const hh = String(hour).padStart(2, '0');
  const mm = String(minute).padStart(2, '0');
  const localMidnight = `${year}-${MM}-${dd} ${hh}:${mm}:00`;
  // This returns the exact UTC instant corresponding to 00:00 in `timeZone`
  return zonedTimeToUtc(localMidnight, timeZone);
};
